module.exports = __webpack_public_path__ + "static/img/car-sample.b08c081.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car-sample.jpg
// module id = moER
// module chunks = 1